import { Component, Input, OnInit } from '@angular/core';
import { IzsStatusEnum } from '../../../shared/enums/izs-status.enum';

@Component({
  selector: 'base-izs-rating',
  templateUrl: './izs-rating.component.html',
})
export class BaseIzsRatingComponent implements OnInit {
  @Input() color: string | undefined;
  @Input() isSmallLogo: boolean = false;
  @Input() hideTooltip: boolean = false;
  izsLogoSrc: string;

  ngOnInit() {
    this.izsLogoSrc = this.setIZSLogoSrc();
  }

  setIZSLogoSrc(): string {
    const statusIsNotDefined =
      !this.color || (this.color && !Object.values(IzsStatusEnum).includes(this.color as IzsStatusEnum));
    const status = statusIsNotDefined ? IzsStatusEnum.GRAY : this.color;

    return `assets-global/images/izs/izs-logo-${status}.svg`;
  }
}
